import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["commissionsFeeId"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-unused-vars */

import { postMainApi, putMainApi, getMainApi, deleteMainApi } from "@Shared/utils/ajax";
import { mapValues, omit } from "lodash";
import Vue from "vue";
export const getCoBrokerBrokerages = async (searchString, offset, limit) => {
  return getMainApi({
    searchString,
    offset,
    limit
  }, "/co-broker/brokerages");
};
export const getCoBrokerAgents = async (agentFirstName, agentLastName, brokerageId, offset, limit, orderBy, orderType) => {
  return getMainApi({
    agentFirstName,
    agentLastName,
    brokerageId,
    offset,
    limit,
    orderBy,
    orderType
  }, "/co-broker/agents");
};
export const getCoBrokerFavorites = async (offset, limit, orderBy, orderType) => {
  return getMainApi({
    offset,
    limit,
    orderBy,
    orderType
  }, "/co-broker/favorites");
};
export const addCoBrokerToFavoritesList = async usernameToFavorite => {
  return postMainApi({}, `/co-broker/favorite?usernameToFavorite=${usernameToFavorite}`);
};
export const removeCoBrokerFromFavoritesList = async usernameToUnfavorite => {
  return deleteMainApi(`/co-broker/favorite?usernameToUnfavorite=${usernameToUnfavorite}`);
};
export const getCoBrokeringHistory = async (clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/co-broker`;
  return getMainApi({}, endpoint);
};
export const getSubmissionHistory = async (clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-direct`;
  return getMainApi({}, endpoint);
};
export const submitApplicationToLender = async (clientUsername, applicationId, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-direct/submit`;
  return postMainApi(data, endpoint);
};
export const toggleDealStatus = async (clientUsername, applicationId, submissionId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-direct/${submissionId}/status`;
  return postMainApi({}, endpoint);
};
export const getValidationRulesResult = async (clientUsername, applicationId, submissionData = {}) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-direct/valid`;
  return postMainApi(submissionData, endpoint);
};
export const getLenders = ({
  all,
  applicationId
}) => {
  return getMainApi({
    all,
    applicationId
  }, "/filogix/data");
};
export const getCurrentAgent = async () => {
  const {
    userDetails,
    brokerageDetails
  } = Vue.auth.session.get();
  const {
    givenName,
    familyName,
    email,
    phoneNumber,
    address
  } = userDetails;
  const {
    name: brokerageName
  } = brokerageDetails.tiedBrokerages[0];
  const agent = {
    address,
    email,
    givenName,
    familyName,
    phoneNumber,
    brokerageName
  };
  return agent;
};
export const getSubmissionAgents = async () => {
  const endpoint = `/brokerage/submission-agent`;
  return getMainApi({}, endpoint);
};
export const createSubmissionAgent = (submissionAgentInfo = {}) => {
  const endpoint = "/brokerage/submission-agent";
  return postMainApi(submissionAgentInfo, endpoint);
};
export const updateSubmissionAgent = (id, submissionAgentInfo = {}) => {
  const endpoint = `/brokerage/submission-agent/${id}`;
  const sanitizedSubmissionAgentInfo = mapValues(submissionAgentInfo, detail => detail || "");
  return putMainApi(sanitizedSubmissionAgentInfo, endpoint);
};
export const assignSubmissionAgent = (clientUsername, applicationId, submissionAgentId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/submission-agent`;
  return putMainApi({
    submissionAgentId
  }, endpoint);
};
export const assignReferralSource = (clientUsername, applicationId, referrerId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/referrer`;
  return putMainApi({
    referrerId
  }, endpoint);
};
export const getCreditSubjects = async (clientUsername, applicationId) => {
  return getMainApi({}, `/client/${clientUsername}/application/${applicationId}/credit-report/subjects`);
};
export const getCreditReports = async (clientUsername, applicationId) => {
  return getMainApi({}, `/client/${clientUsername}/application/${applicationId}/credit-report`);
};
export const getAdditionalReports = async (clientUsername, applicationId) => {
  return getMainApi({}, `/client/${clientUsername}/application/${applicationId}/additional-report`);
};
export const getApplicationFees = async (clientUsername, applicationId) => {
  return getMainApi({}, `/client/${clientUsername}/application/${applicationId}/fee`);
};
export const requestCreditBureau = async ({
  clientUsername,
  applicationId
}, payload) => {
  return postMainApi(payload, `/client/${clientUsername}/application/${applicationId}/credit-report`);
};
export const requestAmlService = async ({
  clientUsername,
  applicationId
}, payload) => {
  return postMainApi(payload, `/client/${clientUsername}/application/${applicationId}/aml-report`);
};
export const getDocumentForms = async (clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/form`;
  return getMainApi("", endpoint);
};
export const printDocumentForms = async (clientUsername, applicationId, forms, submissionId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/form/print`;
  return postMainApi({
    forms,
    submissionId
  }, endpoint);
};
export const getDocumentFormData = async (clientUsername, applicationId, formKey, mortgageType, federal = false) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/form/${formKey}`;
  return getMainApi({
    mortgageType,
    federal
  }, endpoint);
};
export const saveDocumentFormData = async (clientUsername, applicationId, formKey, mortgageType, federal = false, formData) => {
  const params = $.param({
    mortgageType,
    federal
  });
  const endpoint = `/client/${clientUsername}/application/${applicationId}/form/${formKey}?${params}`;
  return postMainApi({
    formData: _objectSpread({}, formData)
  }, endpoint);
};
export const copyLiabilities = async ({
  reportId,
  clientUsername,
  applicationId
}, payload) => {
  return postMainApi(payload, `/client/${clientUsername}/application/${applicationId}/credit-report/${reportId}/liabilities`);
};
export const changeReportSubmitToLender = async ({
  reportId,
  clientUsername,
  applicationId,
  value
}) => {
  return postMainApi({
    submitToLender: value
  }, `/client/${clientUsername}/application/${applicationId}/credit-report/${reportId}`);
};
export const saveFees = async (clientUsername, applicationId, applicationFees) => {
  return putMainApi(applicationFees, `/client/${clientUsername}/application/${applicationId}/fee`);
};
export const createManualResponse = async (clientUsername, applicationId, submissionId, loanDecision) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-direct/${submissionId}`;
  return putMainApi({
    loanDecision
  }, endpoint);
};
export const getMppData = async (clientUsername, applicationId, submissionId) => {
  return getMainApi({
    submissionId
  }, `/client/${clientUsername}/application/${applicationId}/mpp`);
};
export const generateMpp = async (clientUsername, applicationId, submissionId, mortgageType, quote) => {
  const params = $.param({
    submissionId,
    mortgageType,
    quote
  });
  const endpoint = `/client/${clientUsername}/application/${applicationId}/mpp?${params}`;
  return postMainApi({}, endpoint);
};
export const getSubmissionNote = async (clientUsername, applicationId) => {
  return getMainApi({}, `/client/${clientUsername}/application/${applicationId}/lender-submission-note`);
};
export const updateSubmissionNote = (clientUsername, applicationId, lenderNote) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-submission-note`;
  return putMainApi({
    lenderNote
  }, endpoint);
};
export const addCommissionFee = (applicationId, clientUsername, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/fees`;
  return postMainApi({
    mortgageType
  }, endpoint);
};
export const changeCommissionFee = (applicationId, clientUsername, commissionFee) => {
  const {
      commissionsFeeId
    } = commissionFee,
    payload = _objectWithoutProperties(commissionFee, _excluded);
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/fees/${commissionsFeeId}`;
  return putMainApi(omit(payload, ["default"]), endpoint);
};
export const changeDefaultCommissionFee = (applicationId, clientUsername, commissionFee) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/fees/default`;
  const keysToOmitOnDefault = ["commissionsFeeId", "default", "description", "type", "mortgageType"];
  return putMainApi({
    mortgageType: commissionFee.mortgageType,
    [commissionFee.commissionsFeeId]: omit(commissionFee, keysToOmitOnDefault)
  }, endpoint);
};
export const deleteCommissionFee = (applicationId, clientUsername, commissionsFeeId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/fees/${commissionsFeeId}`;
  return deleteMainApi(endpoint);
};
export const getCommissionsFees = (applicationId, clientUsername, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/fees`;
  return getMainApi({
    mortgageType
  }, endpoint);
};
export const printCommissions = (clientUsername, applicationId, mortgage) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/print`;
  return postMainApi({
    mortgage
  }, endpoint);
};
export const updateCommissionDeduction = (clientUsername, applicationId, commissionsDeductionId, deduction) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/deductions/${commissionsDeductionId}`;
  return putMainApi(deduction, endpoint);
};
export const createCommissionDeduction = (applicationId, clientUsername, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/deductions`;
  return postMainApi({
    mortgageType
  }, endpoint);
};
export const deleteCommissionDeduction = (clientUsername, applicationId, commissionsDeductionId) => {
  return deleteMainApi(`/client/${clientUsername}/application/${applicationId}/commissions/deductions/${commissionsDeductionId}`);
};
export const getCommissionDeduction = (clientUsername, applicationId, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/deductions`;
  return getMainApi({
    mortgageType
  }, endpoint);
};
export const getCommissionsDetails = (applicationId, clientUsername, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/details`;
  return getMainApi({
    mortgageType
  }, endpoint);
};
export const getCommissionsDetailsParticipants = (applicationId, clientUsername, mortgageType) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/participants`;
  return getMainApi({
    mortgageType
  }, endpoint);
};
export const addCommissionsDetailsParticipant = (applicationId, clientUsername, mortgageType, participantUsername, agentDetailsEB) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/participants`;
  return participantUsername ? postMainApi({
    mortgageType,
    participantUsername
  }, endpoint) : postMainApi({
    mortgageType,
    agentDetailsEB
  }, endpoint);
};
export const updateParticipantsSplits = (applicationId, clientUsername, agentSplits) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/participants`;
  return putMainApi({
    agentSplits
  }, endpoint);
};
export const updatePrimaryContact = (applicationId, clientUsername, commissionParticipantPrimaryContactId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/participants`;
  return putMainApi({
    commissionParticipantPrimaryContactId
  }, endpoint);
};
export const updateCommissionsDetails = (applicationId, clientUsername, mortgageType, details) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/details?mortgageType=${mortgageType}`;
  return putMainApi(details, endpoint);
};
export const deleteCommissionsDetailsParticipant = (applicationId, clientUsername, commissionsParticipantId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/commissions/participants/${commissionsParticipantId}`;
  return deleteMainApi(endpoint);
};
export const coBrokerApplication = (cobrokerUsername, mortgages, brokerName, brokerageName, clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/co-broker`;
  return postMainApi({
    cobrokerUsername,
    mortgages,
    brokerName,
    brokerageName
  }, endpoint);
};
export const generateLenderNote = (settings, mortgageType, username, clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lender-note/generate`;
  return postMainApi({
    settings,
    mortgageType
  }, endpoint);
};
export const getLenderNoteGenerationSettings = () => {
  const endpoint = `/application/lender-note/settings`;
  return getMainApi({}, endpoint);
};
export const saveLenderNoteGenerationSettings = settings => {
  const endpoint = `/application/lender-note/settings`;
  return postMainApi(_objectSpread({}, settings), endpoint);
};